import instoreHiwModalSaga from './instoreHiwModal';

export default instoreHiwModalSaga;
